import Vue from 'vue'
import CONFIG from './../../config.js'

let actions = {
  getStores (context, params) {

    //context.commit('addLog', { request:'loyaltypoints' })
    Vue.axios.get("https://www.paisawapas.com/partners/getStores?clientId=epaylater&clientSecret=b57f01544997b7d59a582dff7fb1ead6&count=10", {
      params: params,
      /* withCredentials: true, */
      xsrfCookieName: 'SSO_TOKEN'
    }).then((response) => {
      //console.log("get store resposne ------ " + JSON.stringify(response))
      //console.log(response.data.stores)
      context.commit('brandStores', response.data.stores)
    }).catch(()=>{
    })
  }
}

export default actions


// WEBPACK FOOTER //
// ./src/store/shopWithBrands/actions.js